import type { AxiosInstance } from "axios";

import { Actioner } from "@services/actioner";

import ErrorResponseFactory from "@services/sdk/models/error-response-factory";
import Result, {
	type BooleanResult,
	type StringResult,
} from "@services/sdk/models/result";

export interface IAWSAdapter {
	awsIdLookUp(email: string): Promise<StringResult>;
	binCheck(bin: number): Promise<BooleanResult>;
}

export const createAWSAdapter = (
	httpClient: AxiosInstance,
	username: string,
): IAWSAdapter => ({
	awsIdLookUp: async (email: string): Promise<StringResult> => {
		try {
			const response = await httpClient.post("auth/external-id/create", {
				email,
			});
			return Result.Success(response.data.data.externalId);
		} catch (error: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, error);
			return Result.Failure(error);
		}
	},

	binCheck: async (bin: number): Promise<BooleanResult> => {
		try {
			const {
				data: { bin_exist: binExist },
			} = await httpClient.post(
				"/bin/check",
				{ bin },
				{
					auth: {
						username,
						password: "",
					},
				},
			);
			return Result.Success(binExist);
		} catch (error: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, error);
			return Result.Failure(error);
		}
	},
});
